export default __webpack_public_path__ + "static/media/element_56.46ca48b1.webp";